import {
    ErrorObject,
    ExtendedBooleanText,
    Nullable,
    TestStatus,
} from "../../types";

export enum Gender {
    MALE = "Male",
    FEMALE = "Female",
}

export enum ActivityLevel {
    NOT_ACTIVE = "Not active",
    MILDLY_ACTIVE = "Mildly active",
    VERY_ACTIVE = "Very active",
    UNKNOWN = "Unknown",
}

export interface BasicPersonalData {
    age: number;
    bmi: number;
    fat: number;
    firstName: string;
    gender: Gender;
    height: number;
    identification: string;
    lastName: string;
    weight: number;
    status: TestStatus;
    testDate: string;
    testId: number;
}

export type BasicPersonalDataFromAPI = {
    navbar_status: number;
    person: {
        age: number;
        bmi: number;
        fat: number;
        first_name: string;
        gender: Gender;
        height: number;
        identification: string;
        last_name: string;
        weight: number;
    };
    test_date: string;
    test_id: number;
    test_status: "Not completed" | "Interpreted viewed" | "Completed";
};

export type BasicPersonalDataWithErrorsFromAPI = {
    person: {
        active: string | ErrorObject;
        age: number | ErrorObject;
        fat: number | ErrorObject;
        first_name: string | ErrorObject;
        gender: string | ErrorObject;
        height: number | ErrorObject;
        identification: string | ErrorObject;
        last_name: string | ErrorObject;
        race: string | ErrorObject;
        smoker: boolean | ErrorObject;
        weight: number | ErrorObject;
        bmi: number | ErrorObject;
    };
    test_date: string | ErrorObject;
    test_id: number;
};

export interface AdvancedPersonalData {
    active: Nullable<ActivityLevel>;
    race: Nullable<string>;
    smoker: Nullable<ExtendedBooleanText>;
    all_race_types: string[];
}

export type AdvancedPersonalDataFromAPI = {
    active: Nullable<string>;
    race: Nullable<string>;
    smoker: Nullable<ExtendedBooleanText>;
    all_race_types: string[];
};
